import { gql, useLazyQuery, useQuery } from '@apollo/client'
import { IUserProfile } from '@dtos/User'

export const GET_PROFILE = gql`
  query getProfile {
    user {
      id
      firstName
      lastName
      email
      phone
      ddi
      extraPhone
      cpf
      rg
      bornAt
      skype
      companyName
      companyPosition
      biography
      twitter
      facebook
      coverImageUrl
      locale
      address {
        id
        country
        street
        number
        complement
        city
        state
        zipCode
        district
      }
      customFields {
        slug
        type
        label
        value
      }
    }
  }
`

export interface IGetProfileResult {
  user: IUserProfile
}

export const useGetProfile = () => {
  const { data, loading, error, refetch } =
    useQuery<IGetProfileResult>(GET_PROFILE)

  return { profile: data?.user, loading, error, refetch }
}

export const useLazyGetProfile = () => {
  const [getProfile, { data, loading, error }] =
    useLazyQuery<IGetProfileResult>(GET_PROFILE)

  return { getProfile, profile: data?.user, loading, error }
}
